module.exports = __webpack_public_path__ + "src/assets/img/cards.ad9fe5f4.png";